// src/firebase.js
import { initializeApp } from 'firebase/app';
import { getMessaging, getToken, onMessage } from 'firebase/messaging';

const firebaseConfig = {
  apiKey: 'AIzaSyAD3aJ88tpJffA9t6ZFVbrBIpXGN5p1Pcw',
  authDomain: 'serrand-a7206.firebaseapp.com',
  projectId: 'serrand-a7206',
  storageBucket: 'serrand-a7206.firebasestorage.app',
  messagingSenderId: '147827398458',
  appId: '1:147827398458:web:2db7c6f4a12d6a7405a203',
  measurementId: 'G-HDE3BPR4FP',
};

let app;
try {
  app = initializeApp(firebaseConfig);
  console.log('Firebase initialized successfully');
} catch (error) {
  console.error('Firebase initialization failed:', error);
}

let messaging = null;
if (process.env.NODE_ENV === 'production') {
  try {
    messaging = getMessaging(app);
    console.log('Firebase Messaging initialized successfully');
  } catch (error) {
    console.error('Firebase Messaging initialization failed:', error);
  }
} else {
  console.log('Firebase Messaging initialization skipped in development');
}

export { app, messaging, getToken, onMessage };
